import { useMemo } from 'react';

import isNil from 'lodash/isNil';

import { ReasonCode } from '@app/models/api/api-types';
import { selectors } from '@app/state/slices/accommodation.slice';
import { useAppSelector } from '@app/state/state';

export const useIsUnavailable = () => {
    const filters = useAppSelector(selectors.selectFilters);
    const unavailabilityReason = useAppSelector(selectors.selectUnavailabilityReason);
    const isDatesAvailabilityError = useAppSelector(selectors.selectIsDatesAvailabilityError);

    const { checkIn, checkOut } = filters ?? {};
    const isDatesNotSet = useMemo(() => isNil(checkIn) && isNil(checkOut), [checkIn, checkOut]);
    const isUnavailableTooManyGuests = [ReasonCode.RequestNotSatisfied].includes(
        unavailabilityReason as ReasonCode,
    );

    return isDatesNotSet || isUnavailableTooManyGuests || isDatesAvailabilityError;
};
